import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { GitHubApiHttp } from "../../../../services/GitHubApiHttp";
import {
  Loader,
  LoaderSize,
  LoaderTheme,
} from "../../../components/Loader/Loader";
import ConnectGithubAccountForm from "../../../containers/ConnectGithubAccountForm";
import GitHubIntegrationWrapper from "../../../components/GitHubIntegrationWrapper/GitHubIntegrationWrapper";

const {
  default: githubLogo,
} = require("../../../../assets/images/billing/icon-github-small-black.svg");

type LinkedAccountsProps = {
  githubLogin: string;
  getGithubLoginName: () => Promise<void>;
  revokeGithubAccess: () => Promise<void>;
};

function LinkedAccounts({
  githubLogin,
  getGithubLoginName,
  revokeGithubAccess,
}: LinkedAccountsProps) {
  const [isProfileReceived, setIsProfileReceived] = useState(false);
  useEffect(() => {
    getGithubLoginName().then(
      () => {
        setIsProfileReceived(true);
      },
      () => {
        setIsProfileReceived(true);
      }
    );
  }, [getGithubLoginName]);

  const revokeGithubAccessCb = useCallback(() => {
    revokeGithubAccess();
  }, [revokeGithubAccess]);

  return (
    <GitHubIntegrationWrapper>
      <div className="linked-accounts">
        <div className="form-sub-header">Linked Accounts</div>
        {isProfileReceived ? (
          <React.Fragment>
            {githubLogin ? (
              <div className="linked-accounts_account-wrapper">
                <div className="linked-accounts_account">
                  <img src={githubLogo} />
                  {githubLogin}
                </div>
                <div
                  className="action-btn light-red-with-border"
                  onClick={revokeGithubAccessCb}
                >
                  Revoke GitHub access
                </div>
              </div>
            ) : (
              <ConnectGithubAccountForm githubLogin={githubLogin} />
            )}
          </React.Fragment>
        ) : (
          <Loader theme={LoaderTheme.Dark} size={LoaderSize.Small} />
        )}
      </div>
    </GitHubIntegrationWrapper>
  );
}

export default LinkedAccounts;
